export const testimonials = [
  {
    id: 1,
    name: "Lucas Oliveira",
    location: "São Paulo, Brasil",
    avatar: "LO",
    rating: 5,
    text: "A planilha CSSBuy mudou completamente minha forma de comprar da China. Antes eu perdia horas procurando produtos confiáveis, agora tenho tudo organizado em um só lugar. Recomendo demais para quem quer economizar tempo e dinheiro.",
    type: "text",
  },
  {
    id: 2,
    name: "Mariana Costa",
    location: "Lisboa, Portugal",
    avatar: "MC",
    rating: 5,
    text: "Finalmente encontrei uma planilha CSSBuy que realmente é atualizada! Os links funcionam, os produtos têm qualidade, e as comparações me ajudaram a evitar itens ruins. Já fiz 5 compras usando a planilha e todas chegaram perfeitas.",
    type: "text",
  },
  {
    id: 3,
    name: "Pedro Santos",
    location: "Rio de Janeiro, Brasil",
    avatar: "PS",
    rating: 5,
    text: "Como iniciante na CSSBuy, essa planilha foi essencial. Ela me guiou desde os primeiros passos até encontrar os melhores sneakers. A seção de tênis é simplesmente incrível, com comparações reais de qualidade.",
    type: "image",
    image: "https://readdy.ai/api/search-image?query=Young%20man%20with%20curly%20dark%20hair%20wearing%20a%20mustard%20yellow%20hoodie%20leaning%20casually%20against%20a%20textured%20concrete%20pillar%20in%20an%20urban%20setting%2C%20golden%20hour%20sunlight%20on%20his%20face%2C%20candid%20street%20style%20portrait%2C%20warm%20tones%2C%20genuine%20smile%2C%20editorial%20lifestyle%20photography&width=600&height=800&seq=testimonial-v2-pedro&orientation=portrait",
  },
  {
    id: 4,
    name: "Ana Ferreira",
    location: "Porto, Portugal",
    avatar: "AF",
    rating: 5,
    text: "A melhor planilha CSSBuy que já usei! Atualização semanal faz toda diferença. Os produtos novos aparecem rápido e as avaliações são honestas. Uso tanto para compras pessoais quanto para revenda aqui em Portugal.",
    type: "text",
  },
  {
    id: 5,
    name: "Rafael Lima",
    location: "Belo Horizonte, Brasil",
    avatar: "RL",
    rating: 5,
    text: "Depois de muito tempo procurando, achei essa planilha CSSBuy que realmente funciona. Os produtos são verificados, as fotos são reais, e o suporte da comunidade é incrível. Minha taxa de acerto nas compras da China subiu de 60% para 95%.",
    type: "text",
  },
];

export const blogEntry = {
  id: 1,
  title: "Como Comprar na CSSBuy? Guia Completo 2026",
  summary: "Aprenda o passo a passo completo para usar a planilha CSSBuy e fazer compras seguras da China. Guia atualizado com dicas de qualidade, envio e economia para Brasil e Portugal.",
  slug: "guia-cssbuy-sheet-2026",
  image: "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20minimal%20desk%20setup%20with%20an%20open%20laptop%20displaying%20colorful%20spreadsheet%20charts%2C%20a%20notepad%20with%20handwritten%20notes%2C%20round%20glasses%2C%20and%20a%20white%20ceramic%20coffee%20cup%2C%20morning%20sunlight%20casting%20soft%20shadows%20across%20the%20wooden%20desk%2C%20cozy%20productive%20home%20office%20aesthetic&width=800&height=600&seq=blog-v2-entry-01&orientation=landscape",
};